/**
 * @generated SignedSource<<e143b97bc81cea11792b01af4b04b457>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type EntityKind = "COMPANY" | "PERSON" | "%future added value";
export type OpsOwnersPageQuery$variables = {
  search?: string | null | undefined;
};
export type OpsOwnersPageQuery$data = {
  readonly entities: {
    readonly nodes: ReadonlyArray<{
      readonly email: string | null | undefined;
      readonly id: string;
      readonly kind: EntityKind;
      readonly name: string;
      readonly ownedAssets: ReadonlyArray<{
        readonly assetTag: any;
        readonly id: string;
        readonly name: string;
      }>;
      readonly phone: string | null | undefined;
    } | null | undefined> | null | undefined;
  };
};
export type OpsOwnersPageQuery = {
  response: OpsOwnersPageQuery$data;
  variables: OpsOwnersPageQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "search"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v3 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Literal",
        "name": "first",
        "value": 200
      },
      {
        "kind": "Variable",
        "name": "search",
        "variableName": "search"
      }
    ],
    "concreteType": "EntityConnection",
    "kind": "LinkedField",
    "name": "entities",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Entity",
        "kind": "LinkedField",
        "name": "nodes",
        "plural": true,
        "selections": [
          (v1/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "kind",
            "storageKey": null
          },
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "email",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "phone",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Asset",
            "kind": "LinkedField",
            "name": "ownedAssets",
            "plural": true,
            "selections": [
              (v1/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "assetTag",
                "storageKey": null
              },
              (v2/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "OpsOwnersPageQuery",
    "selections": (v3/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "OpsOwnersPageQuery",
    "selections": (v3/*: any*/)
  },
  "params": {
    "cacheID": "ad6c114fbf7c7b31d5a9706f650ef918",
    "id": null,
    "metadata": {},
    "name": "OpsOwnersPageQuery",
    "operationKind": "query",
    "text": "query OpsOwnersPageQuery(\n  $search: String\n) {\n  entities(search: $search, first: 200) {\n    nodes {\n      id\n      kind\n      name\n      email\n      phone\n      ownedAssets {\n        id\n        assetTag\n        name\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "2f75d7ec5285a3c91e809ecad681a264";

export default node;
